<script setup>
import route from 'ziggy'
import { ref, computed } from 'vue'
import { Inertia } from '@inertiajs/inertia'

let cur_route = ref(route().current())

Inertia.on('success', (event) => {
	// user navigated to new page, update cur_route
	cur_route.value = route().current()
})

const mapRoutesToBreadcrumbs = {
	dashboard: {
		name: 'Dashboard',
		href: '/',
	},
	users: {
		name: 'Users',
		href: '/users',
	},
	contacts: {
		name: 'Contacts',
		href: '/contacts',
	},
	organisations: {
		name: 'Organisations',
		href: '/organisations',
	},
	events: {
		name: 'Events',
		href: '/events',
	},
	invoices: {
		name: 'Invoices',
		href: '/invoices',
	},
	'activity-logs': {
		name: 'Activity Log',
		href: '/activity-logs',
	},
	cards: {
		name: 'Payment Methods',
		href: '/cards',
	},
	docs: {
		name: 'Documentation',
		href: '/docs',
	},
	show: {
		name: 'View',
		href: null,
	},
	index: {
		name: 'List',
		href: null,
	},
	create: {
		name: 'Create',
		href: null,
	},
	edit: {
		name: 'Edit',
		href: null,
	},
	settings: {
		name: 'Settings',
		href: '/settings'
	},
	['add-payment-method']: {
		name: 'Adding a Payment Method',
		href: '/docs/adding-a-payment-method',
	},
	['managing-invoices']: {
		name: 'Managing Invoices',
		href: '/docs/managing-invoices',
	},
	['membership-applications']: {
		name: 'Membership Applications',
		href: '/membership-applications',
	}
}

const breadcrumbs = computed(() => {
	const steps = cur_route.value.split('.') // ['dashboard', 'organisations', 'show']
	let mapped = steps
		.filter(step => step.length > 0)
		.map(step => mapRoutesToBreadcrumbs[step])

	if(mapped.includes(undefined)){
		// route not found in mapRoutesToBreadcrumbs
		console.warn(`Can't create breadcrumbs for route: ${cur_route.value} - you may need to add the route to the mapRoutesToBreadcrumbs object in Breadcrumbs.vue`)
		// filter out the undefined values so that the app still works
		mapped = mapped.filter(step => step !== undefined)
	}
	return mapped
})

const location = window.location
</script>

<template>
	<div class="breadcrumbs">
		<Link 
			v-for="item in breadcrumbs" 
			:key="item.name" 
			:href="item.href ?? location.href" 
			class="
				breadcrumb 
				block relative
				rounded-md 
				py-2 px-3 
				font-medium text-gray-900 no-underline
				hover:text-gray-900 hover:bg-gray-50 
			"
		>
			{{ item.name }}
		</Link>
	</div>
</template>

<style>
.breadcrumbs .breadcrumb:not(:first-child):before {
	content: '/';
	left: -18px;
	position: absolute;
	opacity: 0.3;
}
</style>